import { VIDEO, IN_PERSON, REMOTE, TEXT, SLIDES } from "../../constants";
import mixpanel from "mixpanel-browser";
import viewSopTemplate from "./view_sop.html";
import _ from "lodash";
import en from "./en.translation.json";
import es from "./es.translation.json";
import {
    createCloudinaryPollUrl,
    getCloudinaryUrl,
} from "../../../common/common.utils";

class ViewSOPController {
    /* @ngInject */
    constructor($http, ToastService) {
        this.ToastService = ToastService;
        this.$http = $http;
        this.SLIDES = SLIDES;
    }

    $onInit() {
        let ctrl = this;
        if (ctrl.topic.category === SLIDES) {
            ctrl.$http
                .head(createCloudinaryPollUrl(ctrl.content.pdf_public_id))
                .then(
                    function (response) {},
                    function (response) {
                        if (response.status !== 400) {
                            ctrl.ToastService.create(
                                "viewSop.SLIDES_UNAVAILABLE",
                            );
                            return;
                        }
                        let headers = response.headers();
                        let str = headers["x-cld-error"];
                        let max_page_number = str.match(/[0-9]+/);
                        let slides = [];
                        for (let page = 1; page <= max_page_number; page++) {
                            let url = getCloudinaryUrl(
                                "f_auto,pg_" +
                                    page +
                                    ",q_auto:eco/" +
                                    ctrl.content.pdf_public_id,
                            );
                            slides.push(url);
                        }
                        ctrl.content.slideUrls = slides;
                    },
                );
        }
    }
}

export default {
    bindings: {
        topic: "<",
        content: "<",
        account: "<",
    },
    controller: ViewSOPController,
    template: viewSopTemplate,
    name: "viewSop",
    translations: { en, es },
};
